import React from "react";
import '../styles.css';

const PrimaryCell = (cellData) => {
  return <div>{cellData.text}</div>;
};

export default PrimaryCell;
